export type AppVersionInfo = {
  appVersion?: string;
  builtAt?: string;
  shortVersion?: string;
  version: string;
};

export const APP_VERSION_CHECK_INTERVAL_MS = 5 * 60 * 1000;
export const APP_VERSION_URL = '/app-version.json';

export function isAppVersionInfo(value: unknown): value is AppVersionInfo {
  if (!value || typeof value !== 'object') {
    return false;
  }

  const candidate = value as Record<string, unknown>;

  return (
    typeof candidate.version === 'string' && candidate.version.trim().length > 0
  );
}

export function appVersionsDiffer(
  currentVersion: string | null | undefined,
  latestVersion: string | null | undefined,
) {
  return Boolean(
    currentVersion &&
    latestVersion &&
    currentVersion.trim() !== latestVersion.trim(),
  );
}

export async function fetchLatestAppVersion({
  fetchImpl = fetch,
  now = Date.now(),
}: {
  fetchImpl?: typeof fetch;
  now?: number;
} = {}) {
  const response = await fetchImpl(`${APP_VERSION_URL}?t=${now}`, {
    cache: 'no-store',
  });

  if (!response.ok) {
    return null;
  }

  const payload = await response.json();

  return isAppVersionInfo(payload) ? payload : null;
}

export function currentLoadedAppVersion() {
  const globalValue = globalThis as typeof globalThis & {
    __FRIENZZI_APP_VERSION__?: AppVersionInfo;
  };

  return isAppVersionInfo(globalValue.__FRIENZZI_APP_VERSION__)
    ? globalValue.__FRIENZZI_APP_VERSION__
    : null;
}
